import { render, staticRenderFns } from "./EnrichmentForBatchSearch.vue?vue&type=template&id=c2764438&scoped=true"
import script from "./EnrichmentForBatchSearch.vue?vue&type=script&lang=js"
export * from "./EnrichmentForBatchSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2764438",
  null
  
)

export default component.exports